export default function Footer() {
  return (
    <div className="footer">
      <img src="mlogo.svg" className="footlogo" alt="Mocoso" />
      <p>hi@mocoso.co</p>
      <div className="icons">
        <a href="https://www.instagram.com/mocoso.co/" target="_blank" rel="noreferrer" className="foot-icon-wrap">
          <img src="igicon.svg" className="smallfootlogo" alt="Instagram" />
        </a>
        <a href="https://vimeo.com/mocosoco" target="_blank" rel="noreferrer" className="foot-icon-wrap">
          <img src="vimlog.svg" className="smallfootlogo" alt="Vimeo" />
        </a>
        <a href="https://www.linkedin.com/company/mocoso-co/" target="_blank" rel="noreferrer" className="foot-icon-wrap">
          <img src="linkedin.svg" className="smallfootlogo" alt="LinkedIn" />
        </a>
      </div>
    </div>
  )
}
